<kv-editor-container [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups" [inputComponent]="inputComponent"></kv-editor-container>
<!--     <ng-template editorContentTemplate [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups">
        
    </ng-template>
</kv-editor-container> -->

<!-- <div class="editor-submenu" kvCollapseSubmenu>
    <div class="editor-heading">Editing Header</div>
    <div class="sub-menus">
        <div class="sub-menu-container">
            <nb-menu class="editor-menu" [items]="menuItems" tag="editHeaderMenu"></nb-menu>
        </div>
        <div class="edit-container">
            <p>Edit Content</p>
        </div>
    </div>
</div>
 -->